module.exports = __webpack_public_path__ + "static/media/success.3fcb5b8e.svg";